import { LargeDashboardComponent } from "./large/largeDashboard.component";
import { SmallDashboardComponent } from "./small/smallDashboard.component";
import React, { useState, useCallback, memo } from "react";
import { useWalletStore } from "../../providers/userWallet.store";

interface DashboardComponentProps {
    type?: "large" | "small";
    onOpenChange: (open: boolean) => void;
    setActiveService: React.Dispatch<React.SetStateAction<string | null>>;
}

const useBalanceVisibility = (initialState = true) => {
    const [hideBalance, setHideBalance] = useState(initialState);

    const toggleDisplayBalance = useCallback(() => {
        setHideBalance(prev => !prev);
    }, []);

    return { hideBalance, toggleDisplayBalance };
};

export const DashboardComponent = memo(({
                                            type = "large",
                                            setActiveService,
                                            onOpenChange
                                        }: DashboardComponentProps) => {
    const balance = useWalletStore((state) => state.balance);
    const { hideBalance, toggleDisplayBalance } = useBalanceVisibility(true);

    const commonProps = {
        onOpenChange,
        setActiveService,
        toggler: toggleDisplayBalance,
        hideBalance,
        balance
    };

    return type === "large" ? (
        <LargeDashboardComponent {...commonProps} />
    ) : (
        <SmallDashboardComponent {...commonProps} />
    );
});

DashboardComponent.displayName = "DashboardComponent";